import { Injectable } from '@angular/core';
import { SERVER_URL } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Storage } from '@ionic/storage';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor(public http: HttpClient, public authService: AuthService) { }

  web = "web";

  AnalyticsPageView(param) {
    console.log('PAGE VIEW');
    const url = SERVER_URL + '/analytics/log/';
    const headers = this.authService.getAuthHeaders();
    let data = {
      "channel": this.web,
      "action": "page_view",
      "page": param,
    }
    return this.http.post(url, data, headers).toPromise()

  }

  AnalyticsServiceModalView(param) {
    console.log('MODAL VIEW');
    const url = SERVER_URL + '/analytics/log/';
    const headers = this.authService.getAuthHeaders();
    let data = {
      "channel": this.web,
      "action": "page_view",
      "page": "Modal: " + param,
    }
    return this.http.post(url, data, headers).toPromise()
  }

  AnalyticsServiceProductDetail(id) {
    console.log('PRODUCT VIEW');
    const url = SERVER_URL + '/analytics/log/';
    const headers = this.authService.getAuthHeaders();
    let data = {
      "channel": this.web,
      "action": "view_product",
      "params": {
        "product_id": id
      }
    }
    return this.http.post(url, data, headers).toPromise()
  }

  AnalyticsServiceAddToCart(id,) {
    console.log('ADD TO CART');
    const url = SERVER_URL + '/analytics/log/';
    const headers = this.authService.getAuthHeaders();
    let data = {
      "channel": this.web,
      "action": "add_to_cart",
      "params": {
        "product_id": id
      }
    }
    return this.http.post(url, data, headers).toPromise()
  }

  AnalitycsServiceLogin() {
    console.log('LOGIN');
    const url = SERVER_URL + '/analytics/log/';
    const headers = this.authService.getAuthHeaders();
    let data = {
      "channel": this.web,
      "action": "login",
    }
    return this.http.post(url, data, headers).toPromise()
  }

  AnalyticsServiceLogout() {
    console.log('LOGOUT');
    const url = SERVER_URL + '/analytics/log/';
    const headers = this.authService.getAuthHeaders();
    let data = {
      "channel": this.web,
      "action": "logout",
    }
    return this.http.post(url, data, headers).toPromise()
  }

  AnalyticsServiceError(error, trace) {
    const url = SERVER_URL + '/analytics/log/';
    const headers = this.authService.getAuthHeaders();
    let data = {
      "channel": this.web,
      "action": "error",
      "params": {
        "error": error,
        "trace": trace
      }
    }
    return this.http.post(url, data, headers).toPromise()
  }

}
